import { debugLog } from '~publish/helpers/debugLog'

export function logExampleAction(
  action: string,
  commentId: string,
  detail?: string,
): void {
  debugLog('[Community preview]', action, commentId, detail ?? '')
}
